module.exports = __webpack_public_path__ + "static/media/vampire_circle.96227ab6.png";